:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._mt-t-space-lar3294{margin-top:var(--t-space-large);}
:root ._mb-t-space-lar3294{margin-bottom:var(--t-space-large);}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._z-0{z-index:0;}
:root ._grow-1{flex-grow:1;}
:root ._mr-t-space-med104641{margin-right:var(--t-space-medium);}
:root ._ml-t-space-med104641{margin-left:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pr-t-space-med104641{padding-right:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._pl-t-space-med104641{padding-left:var(--t-space-medium);}
:root ._justify-center{justify-content:center;}
:root ._bg-divider{background-color:var(--divider);}
:root ._width-2px{width:2px;}
:root ._height-20px{height:20px;}